module.exports = __webpack_public_path__ + "img/productSatellite_24.38385ca1.png";